import { render, staticRenderFns } from "./QmsForm.vue?vue&type=template&id=b0cdc4ec"
import script from "./QmsForm.vue?vue&type=script&lang=js"
export * from "./QmsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports